'use client';

import { useEffect, useRef } from 'react';

import { useContextTabsContext } from '../context/ContextTabsContext';

import type { ContextTabLocation } from '@web/hooks';

type ContextTabMetadata = Partial<
  Pick<ContextTabLocation, 'name' | 'section' | 'contextLabel' | 'iconKey'>
>;

/** Publishes page-owned dynamic labels to the tab that originated the render. */
export function useContextTabMetadata(metadata: ContextTabMetadata) {
  const context = useContextTabsContext();
  const tabId = context?.currentRouteTabId;
  const currentRoutePageKey = context?.currentRoutePageKey;
  const tabPageKey = context?.snapshot.tabs.find(
    (tab) => tab.id === tabId,
  )?.pageKey;
  const registeredPageKeyRef = useRef(currentRoutePageKey);
  const updateTabMetadata = context?.updateTabMetadata;
  const { name, section, contextLabel, iconKey } = metadata;

  useEffect(() => {
    if (
      !updateTabMetadata ||
      !tabId ||
      currentRoutePageKey !== registeredPageKeyRef.current ||
      tabPageKey !== registeredPageKeyRef.current
    ) {
      return;
    }
    updateTabMetadata(tabId, { name, section, contextLabel, iconKey });
  }, [
    contextLabel,
    currentRoutePageKey,
    iconKey,
    name,
    section,
    tabId,
    tabPageKey,
    updateTabMetadata,
  ]);
}
